import { Wrapper } from "./styles"

export const PageContainer = (props) => {
    return (
        <Wrapper>{props.children}</Wrapper>
    )
}